import React, { useEffect, useState } from "react";
import { Button } from "components/button";
import { RiAddCircleLine, RiDeleteBin6Line } from "react-icons/ri";
import Select from "react-select";
import { TCategory } from "../categories/TCategory";
import { TAdditionalCategoriesGroups } from "types/inventory";

type TProps = {
  itemId: number;
  categories: TCategory[];
  additionalCategoriesGroups: TAdditionalCategoriesGroups[];
  setAdditionalCategoriesGroups: (value: TAdditionalCategoriesGroups[]) => void;
};

const CategoryGroupSelection = ({
  categories,
  additionalCategoriesGroups,
  setAdditionalCategoriesGroups,
}: TProps) => {
  const [subCategoriesMap, setSubCategoriesMap] = useState<{ [key: number]: TCategory[] }>({});

  useEffect(() => {
    // Map parent categories to their respective subcategories
    const subCategoriesByParent: { [key: number]: TCategory[] } = {};
    categories.forEach((category) => {
      if (category.parent_category_id) {
        if (!subCategoriesByParent[category.parent_category_id]) {
          subCategoriesByParent[category.parent_category_id] = [];
        }
        subCategoriesByParent[category.parent_category_id].push(category);
      }
    });
    setSubCategoriesMap(subCategoriesByParent);
  }, [categories]);

  const updateCategoryGroup = (index: number, field: "fk_category_id" | "fk_group_id", value: number | null) => {


    const updatedGroups = additionalCategoriesGroups.map((group, i) =>
      i === index
        ? {
          ...group,
          [field]: value,
          ...(field === "fk_category_id" ? { fk_group_id: null } : {}), // Reset group when category changes
        }
        : group
    );


    setAdditionalCategoriesGroups(updatedGroups);
  };

  const addCategoryGroup = () => {
    setAdditionalCategoriesGroups([
      ...additionalCategoriesGroups,
      { fk_category_id: null, fk_group_id: null },
    ]);
  };

  const removeCategoryGroup = (index: number) => {
    setAdditionalCategoriesGroups(additionalCategoriesGroups.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      {additionalCategoriesGroups.map((item, index) => {
        const selectedCategory = categories.find((cat) => Number(cat.category_id) === Number(item.fk_category_id));
        const subCategories = selectedCategory ? subCategoriesMap[Number(selectedCategory.category_id)] || [] : [];



        return (
          <div key={index} className="flex items-center justify-between space-x-4">
            {/* Category Select */}
            <Select
              className="w-[49%]"
              value={
                item.fk_category_id
                  ? { label: selectedCategory?.category_name || "Unknown", value: Number(item.fk_category_id) }
                  : null
              }
              onChange={(selectedOption) => {
     
                updateCategoryGroup(index, "fk_category_id", Number(selectedOption?.value) || null);
              }}
              options={categories
                .filter((cat) => cat.is_parent_category)
                .map((cat) => ({ label: cat.category_name, value: Number(cat.category_id) }))}
              placeholder="Select Category"
            />

            {/* Group Select (Dependent on selected Category) */}
            <Select
              className="w-[40%]"
              value={
                item.fk_group_id
                  ? { label: subCategories.find((cat) => Number(cat.category_id) === Number(item.fk_group_id))?.category_name || "Unknown", value: Number(item.fk_group_id) }
                  : null
              }
              onChange={(selectedOption) => {

                updateCategoryGroup(index, "fk_group_id", Number(selectedOption?.value) || null);
              }}
              options={subCategories.map((cat) => ({
                label: cat.category_name,
                value: Number(cat.category_id),
              }))}
              placeholder="Select Group"
              isDisabled={!item.fk_category_id || subCategories.length === 0}
            />

            {/* Remove Button */}
            <Button onClick={() => removeCategoryGroup(index)} className="text-red-500">
              <RiDeleteBin6Line />
            </Button>
          </div>
        );
      })}

      <button
        type="button"
        onClick={addCategoryGroup}
        className="flex items-center text-primary hover:text-orange-600 width-full"
      >
        <RiAddCircleLine className="mr-2" />
        Add Additional Category-Group Pair
      </button>
    </div>
  );
};

export default CategoryGroupSelection;
